const IconYouTube = (): JSX.Element => {
  return (
    <>
      <path
        d="M23.3,6.2c-.2-1.2-1.3-2.1-2.5-2.4-1.8-.4-5.2-.7-8.9-.7s-7.1.3-9,.7c-1.2.3-2.3,1.1-2.5,2.4-.2,1.4-.4,3.3-.4,5.8s.2,4.5.5,5.8c.2,1.2,1.3,2.1,2.5,2.4,1.9.4,5.3.7,9,.7s7-.3,9-.7c1.2-.3,2.3-1.1,2.5-2.4.2-1.4.5-3.4.6-5.8-.1-2.5-.4-4.5-.7-5.8ZM8.9,15.9v-7.8l6.8,3.9-6.8,3.9Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconYouTube;
